import React from "react";
import { useServiceWorker } from "../hooks/useServiceWorker";
import { ServiceWorkerUpdateToast } from "./ServiceWorkerUpdateToast";

interface ServiceWorkerProviderProps {
  children: React.ReactNode;
}

export function ServiceWorkerProvider({
  children,
}: ServiceWorkerProviderProps) {
  const {
    isSupported,
    isRegistered,
    isUpdateAvailable,
    isUpdating,
    showUpdateToast,
    updateServiceWorker,
    dismissUpdate,
  } = useServiceWorker();

  // Service Worker wird automatisch registriert durch den Hook
  // Automatisches Update ohne User-Interaktion

  const handleReload = React.useCallback(() => {
    window.location.reload();
  }, []);

  return (
    <>
      {children}

      {/* Automatische Update-Toast (diskret, ohne User-Interaktion) */}
      <ServiceWorkerUpdateToast
        isVisible={showUpdateToast}
        onReload={handleReload}
      />
    </>
  );
}
